import { FloatingArrow, FloatingArrowProps, useMergeRefs } from '@floating-ui/react';
import * as React from 'react';
import { usePopoverContext } from './PopoverLogic';

/*
  Richard comment:
  99% of this is just from floating ui example
  some of it is overkill, but it's easier to just copy and use in our app
*/

export const VoxelPopoverArrow = React.forwardRef<
  SVGSVGElement,
  Omit<FloatingArrowProps, 'context'>
>(({ style, ...props }, propRef) => {
  const { context: floatingContext, ...context } = usePopoverContext();
  const ref = useMergeRefs([context.arrowRef, propRef]);

  if (!floatingContext.open) return null;

  return <FloatingArrow ref={ref} context={floatingContext} {...props} />;
});
